import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, pipe, Subject } from 'rxjs';
import { count, debounceTime, distinctUntilChanged, filter, finalize, first, map, mergeMap, startWith, switchMap, tap } from 'rxjs/operators';
import { Item } from 'src/app/models/item';
import { CartService } from 'src/app/cart/cart.service';
import { CartItem } from 'src/app/cart/cartItem';
import { ItemsService } from '../../../items/items.service';

import { DealService } from '../../services/deal.service';
import { CartState } from '../../state/cart.reducers';
import { Store } from '@ngrx/store';

import * as CartActions from '../../state/cart.actions';
import * as CartSelectors from '../../state/cart.selectors';

@Component({
   selector: 'app-cart-search',
   templateUrl: './cart-search.component.html',
   styleUrls: ['./cart-search.component.css'],
})
export class CartSearchComponent implements OnInit {


   // activeCart$: Observable<Cart>;



   shopForm: FormGroup = this.fb.group({
      shop: ['', Validators.required],
      operation: ['', Validators.required],
      orderCode: ['']
   });




   shops = [
      { name: 'Kadıköy', code: 'KD' },
      { name: 'HobbyGaleri', code: 'HG' },
      { name: 'PuzzleGaleri', code: 'PG' },
      { name: 'Amazon', code: 'AZ' },
      { name: 'Hepsiburada', code: 'HB' },
      { name: 'Trendyol', code: 'TY' },
      { name: 'Diğer', code: 'DI' },
   ];

   operations = [
      { name: 'Satış', code: 'SI' },
      { name: 'Satış iadesi', code: 'SR' },
      { name: 'Alış', code: 'PI' },
      { name: 'Alış iadesi', code: 'PR' },
   ];

   searchField = new FormControl('');

   searchTerm$: Observable<string>;

   searchItems$: Observable<Item[]>;

   constructor(
      private fb: FormBuilder,
      private its: ItemsService,
      private cs: CartService,
      private ds: DealService,
      private store: Store<CartState>
   ) { }

   ngOnInit(): void {

      this.restoreShopForm();

      this.shopForm.valueChanges.pipe(
         tap(shopForm => this.ds.changeDealCode(shopForm))
      ).subscribe();

      this.searchTerm$ =
         this.searchField.valueChanges.pipe(
            startWith(''),
            debounceTime(1000),
            distinctUntilChanged(),
            filter((val: string) => val && val.length > 4),
            // tap(val => {
            //    console.warn('searchTerm$: ', val);
            //    this.store.dispatch(CartActions.getItemsByCode({ code: val }))
         // })
            // switchMap(codestr => codestr as string),
            // mergeMap(codestr => codestr),
            // switchMap( (codestr) => this.store.dispatch(CartActions.getItemsByCode({ code: codestr })))
         );
      // .subscribe(val => this.store.dispatch(CartActions.getItemsByCode({code: val})));
      // .subscribe();

      this.searchTerm$.pipe(
         // tap(term => console.warn('after mapping: ', term)),
         switchMap(async (term) => this.store.dispatch(CartActions.getItemsByCode({ code: term }))),
      ).subscribe();

      this.store.select(CartSelectors.searchResetSignal).pipe(
         filter(signal => signal === true),
         tap(() => {
            // this.searchField.reset();
            this.searchField.setValue('');
            this.store.dispatch(CartActions.searchFieldReset())
         })
      ).subscribe();

      // TODO: unsubscribe???
      // this.searchTerm$.subscribe(str => this.store.dispatch(CartActions.getItemsByCode({code: str})));

      this.searchItems$ = this.store.select(CartSelectors.searchItems);

   }

   restoreShopForm() {

      const codePrefix = this.ds.dealCodePrefix;
      console.log(codePrefix);
      if (codePrefix && codePrefix.length === 4 && codePrefix != 'XXYY') {
         this.shopForm.get('shop').setValue(codePrefix.slice(2, 4));
         this.shopForm.get('operation').setValue(codePrefix.slice(0, 2));
      }

   }

   // TODO: Add a button to the view
   onAddToCart(item: Item) {

      try {
         this.store.dispatch(CartActions.addToCart({ item }));
         // TODO: search alanı  focus yapacak
         this.searchField.reset();

      } catch (err) {
         console.log('an error occured: ', err);
      }
   }

   extractCode(code: string | '') {
      return {
         shop: code ? code.slice(2, 4) : '',
         operation: code ? code.slice(0, 2) : ''
      }
   }

}
